<template>
  <v-ons-page class="l-content l-profil">
    <custom-toolbar backLabel="Retour">{{ $t("Mon profil") }}</custom-toolbar>

    <div class="text-center userPicture">
      <div class="background" :style="{ backgroundImage: 'url(' + user_image + ')' }">
        <v-ons-button class="edit_btn">
          <i class="fas fa-camera"></i>
        </v-ons-button>
        <input type="file" id="image_file" ref="image_file" modifier="material" v-on:change="updateImage"></input>
      </div>
    </div>

    <div class="userInfos">
      <v-ons-button @click="edit" class="edit_btn">
        <i class="fas fa-pencil-alt"></i>
      </v-ons-button>

      <div v-if="user" class="infoContent">
        <div class="container">
          <h2>{{ user.pro_fName }} {{ user.pro_lName }}</h2>
          <div class="info">
            <i class="fas fa-map-marker-alt"></i>
            <div class="infoName">
              {{ user.pro_address }}<br>
              {{ user.pro_zip }} {{ user.pro_city }}, {{ user_country }}
            </div>
          </div>
          <div v-if="user.pro_nie" class="info">
            <div class="noIcon">NIE</div>
            <div class="infoName">
              {{ user.pro_nie }}
            </div>
          </div>
          <div class="info">
            <i class="fas fa-phone"></i>
            <div class="infoName">
              {{ user.pro_tel }}
            </div>
          </div>
          <div class="info">
            <i class="fas fa-mobile"></i>
            <div class="infoName">
              {{ user.pro_mobile }}
            </div>
          </div>
          <div class="info">
            <i class="fas fa-envelope"></i>
            <div class="infoName">
              {{ user.pro_email }}
            </div>
          </div>
          <div class="info">
            <i class="fas fa-user-lock"></i>
            <div class="infoName">
              &bull;&bull;&bull;&bull;&bull;&bull;&bull;&bull;&bull;&bull;
            </div>
          </div>
        </div>
      </div>
    </div>
  </v-ons-page>
</template>

<script>
  import { EventBus } from '../EventBus.js';
  import ProfileEdit from './ProfileEdit.vue';
  
  export default {
    data () {
      return {
        user_image_directory: null,
        user_image: profile_image,
        user: null
      };
    },
    methods: {
      edit() {
        self = this;
        this.$store.commit('navigator/push', {
          extends: ProfileEdit,
          data() {
            return {
              user: self.user
            };
          }
        });
      },
      updateImage() {
        self = this;

        var uploaded_files = this.$refs.image_file.files;
        if(uploaded_files.length) {
          var image_file = this.$refs.image_file.files[0];
          var form_data = new FormData();
          form_data.append('image_file', image_file);
          form_data.append('prospect_id', loggedIn.pro_id);
          form_data.append('x-secundo-auth', loggedIn.token);

          axios
            .post('/users/update-image',
              form_data,
              {
                headers: {
                  'Content-Type': 'multipart/form-data'
                }
              }
            )
            .then(function(response){
              var uploaded_image = response.data;
              if(uploaded_image) {
                self.user_image = self.user_image_directory + uploaded_image;
                EventBus.$emit('updateUserImage', self.user_image);
              }
            });
        }

      }
    },
    computed: {
      user_country() {
        if(this.user.pro_fk_country) {
          var country_name_var = 'cty_name' + this.$i18n.locale.toUpperCase();
          return this.user[country_name_var];
        }

        return null;
      }
    },
    created() {
      axios
        .get('/users/get', {
          params: {
            'x-secundo-auth': loggedIn.token,
            'prospect_id': loggedIn.pro_id,
          }
        })
        .then(response => {
          this.user = response.data;
          this.user_image_directory = url_erp + '/customers/' + this.user.pro_id + '/profile_images/';

          if(this.user.pro_image_filename) {
            this.user_image = this.user_image_directory + this.user.pro_image_filename;
          }
        });
    }
  };
</script>


// WEBPACK FOOTER //
// Profile.vue?0357e9c7